import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Mail, Phone, Globe } from 'lucide-react';

const LOGO = 'https://customer-assets.emergentagent.com/job_ebfcb4ad-e78d-4e26-be19-6338bba630f2/artifacts/tgcpznjt_Nexa_Logo%20icon%20cyan%20.png';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-[#0A1628] text-white py-14">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="Nexa" className="h-8 w-8" />
            <span className="font-bold text-lg tracking-wider">NEXA</span>
          </div>
          <div className="flex flex-wrap items-center gap-6 text-sm text-slate-400">
            <a href="mailto:info@nexa.sa" className="flex items-center gap-2 hover:text-[#00B4D8] transition-colors"><Mail className="w-4 h-4" /> info@nexa.sa</a>
            <a href="tel:+966533993007" className="flex items-center gap-2 hover:text-[#00B4D8] transition-colors"><Phone className="w-4 h-4" /> +966-533-993-007</a>
            <a href="https://www.nexa-sol.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-[#00B4D8] transition-colors"><Globe className="w-4 h-4" /> www.nexa-sol.com</a>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">{t('footer.tagline')}</p>
          <p className="text-xs text-slate-600">{t('footer.rights')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
